module.exports = __webpack_public_path__ + "img/CToC.1e851825.png";